export default "__VITE_ASSET__DyKLefef__"